import React from "react"
import { RouterProvider, createHashRouter } from "react-router-dom"

import MeteredElectricForm from "./MeteredElectricForm"
import MeteredElectricView from "./MeteredElectricView"

const MeteredElectricContainer = () => {
  const router = createHashRouter([
    {
      path: "/",
      element: <MeteredElectricView />,
      children: [
        {
          path: "meters/:id/metered_electrics/new",
          element: <MeteredElectricForm />,
        },
      ],
    },
  ])

  return <RouterProvider router={router} />
}

export default MeteredElectricContainer
